<template>
  <div>
  <b-card v-if="isNotEmpty" class="no-border">
    <b-form>
      <div class="form-group flex-inline-form-md">
        <b-input-group class="fill-width">
          <b-input-group-text slot="prepend">
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input type="text" placeholder="Search shipment by shipment number"
            @input="onChangeSearchQuery($event)"
            v-model="searchQuery"></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-button title="Delete Multiple Shipment" v-b-toggle.form-delete-multiple variant="outline-danger" class="w-100">
            <i class="fa fa-times-circle"></i> Delete Multiple
          </b-button>
        </b-input-group>
        <b-input-group>
          <b-button title="Upload Shipment" v-b-toggle.upload-container variant="outline-primary" class="w-100">
            <i class="fa fa-upload"></i> Upload
          </b-button>
        </b-input-group>
        <b-input-group>
          <b-button @click="createShipment()" variant="success" class="w-100">
            <i class="fa fa-plus"></i>&nbsp; New
          </b-button>
        </b-input-group>
      </div>
    </b-form>
    <div class="row">
      <div class="col-xl-8 col-lg-7"></div>
      <div class="col-xl-4 col-lg-5">
        <b-collapse id="upload-container">
          <b-card>
            <b-form v-on:submit.prevent="onSubmitUpload" @reset="(evt) => evt.preventDefault()">
              <multiselect
                  v-if="isCopp"
                  name="shipment_upload_vehicle"
                  v-model="shipmentUploadVehicle"
                  :options="vehicles"
                  label="reg_no"
                  track-by="id"
                  placeholder="Select vehicle" class="mb-2"/>
              <div v-show="!uploadProcessed">
                <b-form-file class="mb-2" ref="fileInput" :multiple="false" :state="Boolean(fileUpload)" v-model="fileUpload" name="fileInput" accept=".xml, .xls, .xlsx"></b-form-file>
                <br> Selected file: {{fileUpload && fileUpload.name}}
              </div>
              <b-alert show v-show="uploadProcessed" v-bind:variant="uploadAlert">
                <p style="margin-bottom: 0px;" v-if="shipmentFile">
                  {{ uploadResultText }}
                  <a href="#" v-on:click.prevent="uploadProcessed = false" class="alert-link">Upload again.</a>
                </p>
                <p style="margin-bottom: 0px;" v-if="!shipmentFile">
                  <span v-if="uploadResult && isCopp">
                    Upload success
                  </span>
                  <span v-else-if="uploadResult">
                    Upload success, wait until process finish on
                    <router-link class="alert-link" :to="`/shipment_md/orders`">Order List Page.</router-link>
                  </span>
                  <span v-else-if="!uploadResult">
                    {{ uploadResultText }}
                  </span>
                </p>
              </b-alert>
              <br>
              <b-form-checkbox
                v-model="skipLoader"
                name="skip-loader"
              > Skip Loader </b-form-checkbox>
              <hr>
              <b-button :disabled="noFileUploadChosen" type="submit" variant="primary">Start Upload</b-button>
              <b-button
                @click="cancelUpload()"
                v-b-toggle="'upload-container'"
                type="reset"
                variant="outline-secondary"
                class="pull-right">Close</b-button>
            </b-form>
          </b-card>
        </b-collapse>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <b-collapse id="form-delete-multiple">
          <b-card>
            <b-form @submit.prevent="onStartDeleteMultipleShipment">
              <label for="range-date">Date Range</label>
              <b-form-group class="mb-3">
                <date-picker
                  :editable="false"
                  :clearable="false"
                  :shortcuts="false"
                  id="range-date"
                  v-model="removeDateRange"
                  lang="en"
                  type="date"
                  range-separator="to"
                  partial-update
                  format="DD MMM YYYY" range></date-picker>
              </b-form-group>
              <div v-show="false" class="form-group setup-delete-checkbox mb-2">
                  <b-form-checkbox
                    v-model="deleteOrderCheckbox"
                    name="delete-orders-check"
                    value="delete-orders"
                    unchecked-value="no-delete-orders"
                  > Delete Delivery - Orders </b-form-checkbox>
              </div>
              <hr>
              <b-button :disabled="!hasSelectRangeDate" type="submit" variant="danger">Start Delete</b-button>
              <b-button
                @click="resetRemoveDateRange"
                v-b-toggle="'form-delete-multiple'"
                type="reset"
                variant="outline-danger"
                class="pull-right">
                Close
              </b-button>
            </b-form>
          </b-card>
        </b-collapse>
      </div>
    </div>
    <div
      v-if="isFiltered"
      @click="onRemoveFilter"
      class="remove--filter mb-2">
      <i class="fa fa-window-close" aria-hidden="true"></i>
      <span>Clear current filters and sorts.</span>
    </div>
    <b-card>
      <template slot="header">
        <!-- <ui-multiselect
          @select-option="onSelectCompany($event)"
          :initSelect="initSelectCompany"
          :options="companiesData"
          :searchable="true"
          :className="'pull-right ml-2'"
          :selectLabel="'Company'"
          :title="'Filter by company'"
          :placeholder="'Search company'"
          :label="'name'"></ui-multiselect>
        <ui-multiselect
          @select-option="onSelectOrigin"
          :options="locationsByCompanyId"
          :initSelect="initSelectOrigin"
          :searchable="true"
          :className="'pull-right ml-2'"
          :selectLabel="'Origin'"
          :title="'Filter by origin'"
          :placeholder="'Search origin'"
          :selectDisabled="disableLocationElem"
          :label="'name'"></ui-multiselect> -->
        <ui-multiselect
          @select-option="onSelectVehicle"
          :initSelect="initSelectVehicle"
          :options="vehicles"
          :searchable="true"
          :className="'pull-right ml-2'"
          :selectLabel="'Vehicle'"
          :title="'Filter by vehicle'"
          :placeholder="'Search vehicle'"
          :label="'name'"></ui-multiselect>
        <!-- <ui-multiselect
          @select-option="onSelectConfirmation"
          :initSelect="initSelectConfirmations"
          :options="confirmationOptions"
          :putOnTopChecked="false"
          :multiple="true"
          :className="'pull-right ml-2'"
          :selectLabel="'Confirmation'"
          :title="'Filter by confirmation'"
          :label="'name'"></ui-multiselect> -->
        <ui-multiselect
          @select-option="onSelectState"
          :initSelect="initSelectState"
          :options="stateOptions"
          :putOnTopChecked="false"
          :multiple="true"
          :className="'pull-right ml-2'"
          :selectLabel="'State'"
          :title="'Filter by state'"
          :label="'name'"></ui-multiselect>
        <ui-multiselect
          @select-option="onSelectSort"
          :initSelect="initSelectSort"
          :putOnTopChecked="false"
          :options="sortOptions"
          :className="'pull-right ml-2'"
          :selectLabel="'Sort'"
          :title="'Sort by'"
          :label="'name'"></ui-multiselect>
      </template>
      <b-table striped responsive
        :items="(isLoaded ? table.items : dataBeforeLoad)"
        :fields="table.fields"
        :class="isLoading ? 'show__blur' : ''">
        <template #cell(number)="data">
          <router-link :to="`/shipment_md/shipments/${data.item.id}`">{{data.value}}</router-link>
        </template>
        <template #cell(origin)="data">
          {{ data.value.code }} {{ data.value.name }}
        </template>
        <template #cell(truck)="data">
          <div v-if="data.item.vehicle.id !== undefined">
            <router-link
              :to="`/vehicles/${data.item.vehicle.id}`">{{data.item.vehicle.reg_no}}</router-link>
            <div class="small text-muted"><i class="fa fa-building-o" aria-hidden="true"></i> {{get(data, 'item.vehicle.company.name')}} </div>
          </div>
          <div v-else-if="isCapralConfig">
            <span title="Unregistered">{{ get(data, 'item.metadata.EXTI2', '') }}</span>
          </div>
        </template>
        <template #cell(driver)="data">
          <div v-if="isCapralConfig">
            <span>{{ getDriverFromExt(data.item) }}</span>
          </div>
          <div v-else>
            <router-link
              :to="`/employees/${getDriver(data.item, 'id')}`" v-if="getDriver(data.item, 'name') !== '-'">{{getDriver(data.item, 'name')}}</router-link>
            <span v-if="getDriver(data.item, 'name') === '-'">-</span>
          </div>
        </template>
        <template #cell(load_confirmation)="data">
          <div class="small">
            <confirm-checklist :confirmed="getConfirmation(data.item, 'loader_1')" :adt-data="getConfirmation(data.item, 'loader_1')"> Loader</confirm-checklist>
            <confirm-checklist :confirmed="getConfirmation(data.item, 'driver_1')" :adt-data="getConfirmation(data.item, 'driver_1')"> Driver</confirm-checklist>
            <!-- <confirm-checklist :confirmed="getConfirmation(data.item, 'w_operator')" :adt-data="getConfirmation(data.item, 'w_operator')"> Weighing</confirm-checklist> -->
            <confirm-checklist :confirmed="getConfirmation(data.item, 'driver_2')" :adt-data="getConfirmation(data.item, 'driver_2')"> Driver Finish</confirm-checklist>
          </div>
        </template>
        <template #cell(status)="data">
          {{ getAsStatus(data.item.state) }}
        </template>
        <template #cell(delivery_date)="data">{{formatDate(data.value)}}</template>
        <template #cell(leaving_time)="data">{{formatDateTime(data.item.metadata.time_out)}}</template>
      </b-table>
      <div
        class="show__loading"
        v-if="isLoading"
        :style="`height: ${dataBeforeLoad.length*75+50}px;`">
        <i
          class="fa fa-spinner fa-pulse fa-4x fa-modify"
          alt="Loading"
          :style="`margin-top: ${(dataBeforeLoad.length*75+50)/2}px;`"></i>
      </div>
    </b-card>
    <nav aria-label="Shipment pagination" class="pull-right">
      <ul class="pagination">
        <li class="page-item" :class="{disabled: prevDisabled}">
          <a class="page-link" href="#" @click.prevent="prevPage()"><span aria-hidden="true">&laquo;</span> Previous</a>
        </li>
        <li class="page-item" :class="{disabled: nextDisabled}">
          <a class="page-link" href="#" @click.prevent="nextPage()">Next <span aria-hidden="true">&raquo;</span></a>
        </li>
      </ul>
    </nav>
  </b-card>
  <b-alert show v-else-if="loaded">There's no shipment data.</b-alert>
  </div>
</template>
<script>
import { titleCase } from 'change-case';
import dateMixin from '@/mixins/date';
import userMixin from '@/mixins/user';
import {
  throttle, last, get, isEmpty, filter,
  chain, compact, includes, omit, isObject,
  cloneDeep, isNull, isArray,
} from 'lodash';
import ConfirmChecklist from '@/components/ConfirmChecklist';
import UiMultiselect from '@/components/UiMultiselect';
import Multiselect from 'vue-multiselect';
import tmsApi from '@/api/tmsApi';
import DatePicker from 'vue2-datepicker';
import { format } from 'date-fns';

export default {
  name: 'shipment_list',
  mixins: [dateMixin, userMixin],
  components: {
    UiMultiselect,
    ConfirmChecklist,
    DatePicker,
    Multiselect,
  },
  data() {
    return {
      removeDateRange: null,
      deleteOrderCheckbox: 'delete-orders',
      companiesData: [],
      shipmentFile: true,
      fileUpload: null,
      uploadProcessed: false,
      uploadResult: false,
      shipmentUploadVehicle: null,
      loaded: false,
      searchQuery: '',
      lastData: null,
      lastDataAr: [],
      selectedCompany: null,
      initSelectCompany: null,
      selectedOrigin: null,
      initSelectOrigin: null,
      selectedVehicle: null,
      initSelectVehicle: null,
      currentSort: null,
      initSelectSort: null,
      selectedStates: [],
      initSelectState: [],
      selectedConfirmations: [],
      initSelectConfirmations: null,
      locationsByCompanyId: [],
      vehiclesByCompanyId: [],
      dataBeforeLoad: [],
      uploadResultText: '',
      sortOptions: [
        { id: 1, value: 'NUMBER.ASC', name: 'Number 0-9' },
        { id: 2, value: 'NUMBER.DESC', name: 'Number 9-0' },
        { id: 3, value: 'CREATED_AT.DESC', name: 'Last Created' },
        { id: 4, value: 'CREATED_AT.ASC', name: 'Oldest Created' },
      ],
      stateOptions: [
        { id: 1, value: 'CREATED', name: 'Created' },
        { id: 2, value: 'READY_TO_LOAD', name: 'Ready to Load' },
        { id: 3, value: 'FINISH_LOADING', name: 'Finish Loading' },
        { id: 4, value: 'ON_PROCESS', name: 'On Process' },
        { id: 5, value: 'FINISH', name: 'Finish' },
      ],
      confirmationOptions: [
        { id: 1, value: 'DRIVER', name: 'Driver' },
        { id: 2, value: 'LOADER', name: 'Loader' },
        { id: 3, value: 'W_OPERATOR', name: 'Operator' },
      ],
      table: {
        fields: ['number', 'origin', 'truck', 'driver', 'load_confirmation', 'delivery_date', 'leaving_time'],
        items: [],
      },
      filter: {
        companyField: true,
        originField: true,
        vehicleField: true,
        confirmationField: true,
        stateField: true,
      },
      sortType: null,
      singleVehicleShipment: true,
      skipLoader: false,
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'shipments', name: 'Shipments' },
    ]);
    if (this.isCopp) {
      this.table.fields = [
        'number',
        'origin',
        'truck',
        'driver',
        'status',
        'delivery_date',
        'leaving_time',
      ];
    }
    // this.loadCompaniesData();
    this.$store.commit('shipment_md/shipments/CLEAR_QUERY');
    // this.$store.dispatch('shipment_md/shipments/LOAD_LOCATIONS');
    this.$store.dispatch('shipment_md/shipments/LOAD_VEHICLES');
    // this.$store.dispatch('shipment_md/shipments/LOAD_DATA').then(() => {
    // this.loaded = true;
    this.initFromUrl();
    // });
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
    isCopp() {
      return this.$store.getters.isCopp;
    },
    shipments() {
      return this.$store.getters['shipment_md/shipments/shipments'];
    },
    locations() {
      return this.$store.getters['shipment_md/shipments/locations'];
    },
    vehicles() {
      const vehicles = this.$store.getters['shipment_md/shipments/vehicles'];
      vehicles.forEach((vehicle) => {
        vehicle.name = vehicle.reg_no;
        return true;
      });
      return vehicles;
    },
    isNotEmpty() {
      return true;
    },
    prevDisabled() {
      return this.lastData === null;
    },
    nextDisabled() {
      return this.shipments.length < 10;
    },
    noFileUploadChosen() {
      return this.fileUpload == null;
    },
    uploadAlert() {
      return this.uploadResult ? 'success' : 'danger';
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    isFiltered() {
      const filtered =
        !isEmpty(this.selectedCompany) ||
        !isEmpty(this.selectedOrigin) ||
        !isEmpty(this.selectedVehicle) ||
        !isEmpty(this.selectedStates) ||
        !isEmpty(this.selectedConfirmations) ||
        !isEmpty(this.currentSort);
      return filtered;
    },
    disableLocationElem() {
      return isEmpty(this.selectedCompany) || isEmpty(this.locationsByCompanyId);
    },
    disabledVehicleElem() {
      return isEmpty(this.selectedCompany) || isEmpty(this.vehiclesByCompanyId);
    },
    shipmentGetters() {
      return this.$store.getters['shipment_md/shipments/dataStateShipments'];
    },
    isLoading() {
      return this.shipmentGetters === 'LOADING';
    },
    isLoaded() {
      return this.shipmentGetters === 'LOADED';
    },
    isDeleteOrders() {
      return this.deleteOrderCheckbox === 'delete-orders';
    },
    hasSelectRangeDate() {
      let hasSelectDate = true;

      if (isEmpty(this.removeDateRange)) {
        hasSelectDate = false;
      }

      if (isArray(this.removeDateRange)) {
        hasSelectDate = !isNull(this.removeDateRange[0]);
      }

      return hasSelectDate;
    },
  },
  watch: {
    shipments(data) {
      this.table.items.splice(0);
      data.forEach((d) => {
        this.table.items.push(d);
      });
    },
  },
  methods: {
    initFromUrl() {
      const { query } = this.$route;

      if (query.q !== undefined) {
        this.onChangeSearchQuery(query.q, true);
      }

      if (query.company_id !== undefined) {
        this.onSelectCompany(query.company_id, true);
      }

      if (query.origin_id !== undefined) {
        this.onSelectOrigin(query.origin_id, true);
      }

      if (query.sort !== undefined) {
        this.onSelectSort(query.sort, true);
      }

      if (query.vehicle_id !== undefined) {
        this.onSelectVehicle(query.vehicle_id, true);
      }

      if (query.states !== undefined) {
        this.onSelectState(query.states, true);
      }

      if (query.confirmations !== undefined) {
        this.onSelectConfirmation(query.confirmations, true);
      }

      this.loadData();
    },
    resetPagination() {
      this.lastData = null;
      this.lastDataAr = [];
    },
    updateSearchQuery: throttle((context, searchTerm) => {
      const searchQuery = searchTerm.trim();
      context.resetPagination();
      context.$store.commit('shipment_md/shipments/SET_QUERY_SEARCH', searchQuery);
      context.loadData();
    }, 500, {
      leading: false,
    }),
    loadData() {
      this.dataBeforeLoad = cloneDeep(this.shipments);
      this.$store.commit('shipment_md/shipments/SET_QUERY_LAST_DATA', this.lastData);
      if (this.searchQuery.trim() !== '') {
        return this.$store.dispatch('shipment_md/shipments/FIND_DATA');
      }
      return this.$store.dispatch('shipment_md/shipments/LOAD_DATA');
    },
    prevPage() {
      this.lastDataAr.pop();
      if (this.lastDataAr.length) {
        this.lastData = last(this.lastDataAr);
      } else {
        this.lastData = null;
      }
      this.loadData();
    },
    nextPage() {
      const shipment = last(this.shipments);
      this.lastDataAr.push(shipment.id);
      this.lastData = shipment.id;
      this.loadData();
    },
    getConfirmation(data, key) {
      return data.confirmations.find(c => c.key === key);
    },
    getDriverFromExt(data) {
      const names = get(data, 'metadata.EXTI1', '').split(' ');
      names.pop();
      return titleCase(names.join(' ').toLowerCase());
    },
    getDriver(data, key) {
      // const driverVehicle = get(data, 'vehicle.driver');
      const driver = get(data, 'driver');
      let value = '-';

      // if (!isEmpty(driverVehicle) || !isEmpty(driver)) {
      //   value = isEmpty(driver) ? driverVehicle[key] : driver[key];
      // }

      if (!isEmpty(driver)) {
        value = driver[key];
      }

      return value;
    },
    getAsStatus(state) {
      if (state === 'CREATED') return 'Created';
      if (state === 'FINISH_LOADING') return 'Not Started';
      if (state === 'ON_PROCESS') return 'On Process';
      if (state === 'FINISH') return 'Finish';
      if (state === 'READY_TO_LOAD') return 'Ready to Load';
      return 'Unknown';
    },
    createShipment() {
      this.$router.push('/shipment_md/shipments/create');
    },
    cancelUpload() {
      this.$refs.fileInput.reset();
      this.singleVehicleShipment = true;
      this.uploadProcessed = false;
    },
    onSubmitUpload() {
      const type = 'shipment_xml';
      const payload = {
        file_type: type,
      };
      if (this.shipmentUploadVehicle) {
        payload.vehicle = this.shipmentUploadVehicle.id;
      }

      tmsApi.uploadAuth(this.token, {
        file: this.fileUpload,
        skip_loader: this.skipLoader,
      }, payload).then((res) => {
        this.shipmentFile = !res.isOrderData;
        const isSuccess = this.get(res, 'result.0.status') === true;
        const isSuccessGenFile = this.get(res, 'result.0.resp.status') === true;
        this.uploadResultText = this.get(res, 'result.0.resp.desc');

        if (isSuccess) {
          this.$refs.fileInput.reset();
          this.uploadResult = res.isOrderData ? isSuccessGenFile : true;
          this.uploadProcessed = true;
        } else {
          this.uploadResult = false;
          this.uploadProcessed = true;
        }

        if (this.isCopp) {
          this.resetPagination();
          this.loadData();
        }

        this.skipLoader = false;
      });
    },
    onRemoveFilter() {
      const unSelectButtons = document.querySelectorAll('.filtered .ui-unselect--option');
      unSelectButtons.forEach((el) => {
        el.click();
      });
    },
    onSelectCompany(newValue, fromInit = false) {
      const { locations, vehicles } = this;
      const companyId = isObject(newValue) ? newValue.id || null : newValue;
      const parentId = get(newValue, 'parent.id') || null;
      const partners = get(newValue, 'partners') || [];
      const transporterId = chain(partners)
        .filter(partner => partner.type === 'TRANSPORTER')
        .head()
        .get('company.id')
        .value() || null;
      const relatedIds = compact([companyId, parentId, transporterId]);
      this.$store.commit('shipment_md/shipments/SET_COMPANY_ID', companyId);
      this.selectedCompany = companyId;

      const setupOriginVehicleSelector = () => {
        this.selectedOrigin = null;
        this.selectedVehicle = null;
        this.locationsByCompanyId.splice(0);
        this.vehiclesByCompanyId.splice(0);
        this.locationsByCompanyId = filter(locations, { company: { id: companyId } });
        this.vehiclesByCompanyId = vehicles.filter(vehicle => includes(relatedIds, get(vehicle, 'company.id').toString()));
      };

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...this.$route.query,
            company_id: fromInit ? newValue : newValue.id,
          },
        });
      } else {
        this.$router.push({ query: { ...omit(this.$route.query, ['company_id']) } });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectCompany = companyId;
      }

      setupOriginVehicleSelector();
    },
    onSelectOrigin(newValue, fromInit = false) {
      const originId = isObject(newValue) ? newValue.id || null : newValue;
      this.$store.commit('shipment_md/shipments/SET_ORIGIN_ID', originId);
      this.selectedOrigin = originId;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...this.$route.query,
            origin_id: fromInit ? newValue : newValue.id,
          },
        });
      } else {
        this.$router.push({ query: { ...omit(this.$route.query, ['origin_id']) } });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectOrigin = originId;
      }
    },
    onSelectSort(newValue, fromInit = false) {
      const { query } = this.$route;
      const sortValue = isObject(newValue) ? newValue.value || null : newValue;
      this.currentSort = sortValue;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            sort: sortValue,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['sort']),
          },
        });
        return;
      }

      const { id } = this.sortOptions.find(s => s.value === sortValue);
      this.$store.commit('shipment_md/shipments/SET_QUERY_SORT', sortValue);

      if (!fromInit) {
        this.loadData();
      } else {
        this.initSelectSort = id;
      }
    },
    onSelectVehicle(newValue, fromInit = false) {
      const { query } = this.$route;
      const vehicleId = isObject(newValue) ? newValue.id || null : newValue;
      const vehicle = this.vehicles.find(v => v.ud === vehicleId);
      this.$store.commit('shipment_md/shipments/SET_VEHICLE_ID', vehicleId);
      this.selectedVehicle = vehicle;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            vehicle_id: vehicleId,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['vehicle_id']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectVehicle = vehicleId;
      }
    },
    onSelectState(newValue, fromInit = false) {
      const { query } = this.$route;
      const formatState = (states) => {
        const selectedState = [];
        states.split(',').forEach((state) => {
          const matchState = this.stateOptions.find(s => s.value === state);
          selectedState.push(matchState);
        });
        return selectedState;
      };
      const states = [];
      const statesId = [];
      const stateValue = isObject(newValue) ? newValue : formatState(newValue);
      stateValue.forEach((state) => {
        states.push(get(state, 'value'));
        statesId.push(get(state, 'id'));
      });
      this.$store.commit('shipment_md/shipments/SET_STATE_FILTER', states);

      if (!isEmpty(newValue)) {
        this.selectedStates = newValue;
        this.$router.push({
          query: {
            ...query,
            states: states.join(','),
          },
        });
      } else {
        this.selectedStates = null;
        this.$router.push({
          query: {
            ...omit(query, ['states']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectState = statesId;
      }
    },
    onSelectConfirmation(newValue, fromInit = false) {
      const { query } = this.$route;
      const formatConfirmation = (confirmations) => {
        const selectedConfirmation = [];
        confirmations.split(',').forEach((confirmation) => {
          const matchConfirmation = this.confirmationOptions.find(c => c.value === confirmation);
          selectedConfirmation.push(matchConfirmation);
        });
        return selectedConfirmation;
      };
      const confirmations = [];
      const confirmationsId = [];
      const confirmationValue = isObject(newValue) ? newValue : formatConfirmation(newValue);
      confirmationValue.forEach((confirmation) => {
        confirmations.push(get(confirmation, 'value'));
        confirmationsId.push(get(confirmation, 'id'));
      });
      this.$store.commit('shipment_md/shipments/SET_CONFIRMATION_FILTER', confirmations);

      if (!isEmpty(newValue)) {
        this.selectedConfirmations = newValue;
        this.$router.push({
          query: {
            ...query,
            confirmations: confirmations.join(','),
          },
        });
      } else {
        this.selectedConfirmations = null;
        this.$router.push({
          query: {
            ...omit(query, ['confirmations']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectConfirmations = confirmationsId;
      }
    },
    get(obj, key) {
      return get(obj, key);
    },
    onChangeSearchQuery(newValue, fromInit = false) {
      this.$store.commit('shipment_md/shipments/SET_QUERY_SEARCH', newValue);
      if (!isEmpty(newValue)) {
        this.$router.push({ query: { ...this.$route.query, q: newValue } });
      } else {
        this.$router.push({ query: { ...omit(this.$route.query, ['q']) } });
      }
      this.searchQuery = newValue;

      if (!fromInit) {
        this.updateSearchQuery(this, newValue);
      }
    },
    // loadCompaniesData() {
    //   const useTenants = !this.isSystemAdmin ? 1 : 0;
    //   this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: useTenants })
    //   .then((data) => {
    //     this.companiesData = data;
    //   });
    // },
    onStartDeleteMultipleShipment() {
      if (!this.removeDateRange) return false;

      const startDate = get(this.removeDateRange, '0', '');
      const endDate = get(this.removeDateRange, '1', '');
      const startHumanDate = format(startDate, 'DD MMM YYYY');
      const endHumanDate = format(endDate, 'DD MMM YYYY');

      this.$swal({
        title: 'Delete Confirmation',
        html: `Are you sure want to <b>delete</b> shipments ? <br> From <b>${startHumanDate}</b> until <b>${endHumanDate}</b>`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          const payloads = {
            delete_order: this.isDeleteOrders,
            start_date: format(startDate, 'YYYY-MM-DD'),
            end_date: format(endDate, 'YYYY-MM-DD'),
          };
          this.$store.dispatch('shipment_md/shipments/RESTART_SHIPMENT_DATA', payloads).then(() => {
            this.$swal('Success', 'Successfully delete shipments.', 'info').then(() => {
              this.resetPagination();
              this.loadData();
            });
          });
        }
      });

      return true;
    },
    resetRemoveDateRange() {
      this.removeDateRange = null;
    },
  },
};
</script>
<style lang="sass">
.table td
  vertical-align: middle
.remove--filter
  font-weight: bold;
  cursor: pointer;
  color: #e66f6f;
.remove--filter
  i
    font-size: 17px;
.remove--filter:hover
  color: #0366d6;
@media screen and (max-width: 320px)
  .ui-dropdown-modal-holder
    width: 250px !important
</style>

<style lang="sass" scoped>
.show__loading
  height: 800px
  top: 75px
  width: 96.5%
  position: absolute
  opacity: 0.3
  background-color: #9E9E9E

  >img
    height: 50px
    width: 50px
    margin-left: 50%

.show__blur
  -webkit-filter: blur(1px)
  -moz-filter: blur(1px)
  -ms-filter: blur(1px)
  -o-filter: blur(1px)
  filter: blur(1px)

.fa-modify
  color: #000000;
  margin-left: 45%;
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/shipments/List.vue